const numberInputOnWheelPreventChange = e => {
  e.target.blur();
};

export default numberInputOnWheelPreventChange;
